{
  "loading": "جارٍ التحميل...",
  "loadingMore": "جارٍ تحميل المزيد..."
}
